import {create} from 'zustand';

interface ContractDocumentDeleteModalState {
  deletableId: string | null;

  documentDeleteModalOpen: (deletableId: string) => void;
  documentDeleteModalClose: () => void;
}

export const useContractDocumentDeleteModalStore = create<ContractDocumentDeleteModalState>((set) => ({
  deletableId: null,

  documentDeleteModalOpen: (deletableId: string) => set({deletableId}),
  documentDeleteModalClose: () => set({deletableId: null}),
}));

export const {documentDeleteModalClose, documentDeleteModalOpen} = useContractDocumentDeleteModalStore.getState();
